import { GoalTypeDTO } from '../../types/goalsDTO';
import { MIGRATED_GOALS } from '../GoalPage.constants';

export const getGoalPageName = (goalType: GoalTypeDTO) => {
  return MIGRATED_GOALS.includes(goalType) ? 'Goal' : 'NewFinancialPlanWhatIfs';
};
